import { Injectable } from '@angular/core';
import { AuthenticationHydrationRule } from './rules/authentication-hydration.rule';
import { ValidateAuthenticationRule } from './rules/validate-authentication.rule';
import { AuthCalculationRule } from './auth.domain';

@Injectable({
	providedIn: 'root',
})
export class AuthFactoryService {

	/**
	 * Devuelve las reglas de precios de los items segun el orden requerido
	 */
	public getAuthRules(): AuthCalculationRule[] {
		return [
			new ValidateAuthenticationRule(),
			new AuthenticationHydrationRule(),
		];
	}
}
